import React from 'react'

function Alert(props) {
    const capitalizeWord=(word)=>{
        const lower=word.toLowerCase();
        return lower.charAt(0).toUpperCase()+lower.slice(1);
    }
  return (
    <div style={{height:'1rem',textAlign:'center', display: 'flex',justifyContent: 'center', alignItems: 'center',position: 'relative',whiteSpace:'nowrap',marginTop:'2.3rem'}}>
    {props.alert && <div className={`alert alert-${props.alert.type} alert-dismissible fade show`} role="alert">
        <strong>{capitalizeWord(props.alert.type)}</strong>:{props.alert.msg} 
    </div>}
    </div>
  )
}

export default Alert